import { type Canary, canaryHeaderName, toVariant } from './canaries';

/**
 * Reads the canary decision the middleware stamped on `x-canary-<id>`, typed to that canary's
 * variants. Never throws: an absent or unrecognised header falls back to `control`, so a route the
 * middleware skipped — or a header supplied by the client — cannot force a treatment.
 */
export const getCanaryVariant = async <TVariant extends string>(canary: Canary<TVariant>): Promise<TVariant> => {
    try {
        const { headers } = await import('next/headers');
        const stamped = (await headers()).get(canaryHeaderName(canary));

        return toVariant(canary, stamped) ?? canary.control;
    } catch {
        return canary.control;
    }
};
